<div style="display: grid">
  <div
    #tabViewContainer
    class="u-tab-view"
    [class.primary]="isPrimary()"
    cdkDropListOrientation="horizontal"
    cdkDropList
    (cdkDropListDropped)="drop($event)"
  >
    <div #tabsContainer class="u-tab-view-content">
      @if (tabsStaticCurrent()?.length) {
        <div #static class="u-tab-container">
          @for (tab of tabsStaticCurrent().slice(0, staticTabsLimit()); track tab.id) {
            <div
              #staticTabs
              class="u-tab"
              (click)="openTab(tab)"
              (contextmenu)="openContextMenu($event, tab.id)"
              [ngClass]="{
                'active-tab': tab.id === selectedTabId() || (!selectedTabId() && tab.id === activeTabId()),
                'disabled-tab': tab.disabled,
              }"
              [pTooltip]="tab.tooltip"
              tooltipPosition="top"
              tooltipStyleClass="u-tooltip"
            >
              <span class="tab-content">
                @if (tab.icon) {
                  <u-icon [ngClass]="{ 'tab-icon': tab.name }" [model]="{ type: 'font', value: tab.icon }"></u-icon>
                }
                @if (tab.name) {
                  <span class="tab-name">{{ tab.name }}</span>
                }
              </span>
              @if (!checkIsNil(tab) && tab.amount) {
                <span class="tab-amount">{{ tab.amount }}</span>
              }
            </div>
          }
        </div>
      }
      <div #moving class="u-tab-container">
        @if (tabsMovingCurrent()?.length > 0) {
          @for (tab of tabsMovingCurrent().slice(0, movingTabsLimit()); track $index) {
            <div
              #movingTabs
              class="u-tab"
              [ngClass]="{ 'active-tab': tab?.id === selectedTabId() || (!selectedTabId() && tab?.id === activeTabId()) }"
              (click)="openTab(tab)"
              (contextmenu)="openContextMenu($event, tab?.id)"
              [pTooltip]="tab?.tooltip"
              tooltipPosition="top"
              tooltipStyleClass="u-tooltip"
              [cdkDragDisabled]="tab?.editMode"
              cdkDrag
            >
              @if (tab?.icon) {
                <u-icon class="tab-icon" [model]="{ type: 'font', value: tab.icon }"></u-icon>
              }

              @if (tab?.editMode) {
                <u-input
                  [model]="tab.name"
                  [placeholder]="tab.name"
                  [styles]="INPUT_STYLES"
                  [autoFitWidthEnabled]="true"
                  [selectTextAfterInit]="true"
                  [clearIconBehavior]="'never'"
                  (onEnter)="renameTab($event, tab)"
                  (onBlur)="renameTab($event, tab)"
                  (onKeydown)="onKeydown($event, tab)"
                ></u-input>
              } @else if (tab) {
                <span>{{ tab.name }}</span>
              }
            </div>
          }
        }
      </div>
      @if (tabsActionStatic()?.length && !showOnOptions()[0]?.items?.length) {
        <div>
          @for (tab of tabsActionStatic(); track tab.id) {
            <div
              class="u-tab action"
              (click)="doAction($event, tab?.name)"
              [pTooltip]="tab.tooltip"
              tooltipPosition="top"
              tooltipStyleClass="u-tooltip"
            >
              <u-icon class="static-action-tab-icon" [model]="{ type: 'font', value: tab.icon }" [styles]="{ fontSize: '10px' }"></u-icon>
            </div>
          }
        </div>
      }
      @if (showMoreOptions()) {
        <u-menubar class="more-menubar" [items]="showOnOptions()" (itemClick)="openTab($event)"></u-menubar>
      }
    </div>
    <div class="content"><ng-content></ng-content></div>
  </div>
</div>
